import React, { useEffect } from 'react';
import { CheckCircle, AlertTriangle, X } from 'lucide-react';

// --- Helper: Inject CSS Keyframes for Animations ---
if (!document.getElementById('alert-keyframes')) {
    const keyframes = `
    @keyframes slideIn {
      from { transform: translateY(-30px); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }
    @keyframes fadeOut {
      from { opacity: 1; }
      to { opacity: 0; }
    }
    `;
    const styleSheet = document.createElement("style");
    styleSheet.id = 'alert-keyframes';
    styleSheet.type = "text/css";
    styleSheet.innerText = keyframes;
    document.head.appendChild(styleSheet);
}
// --- End Helper ---


const CustomAlert = ({ message, type = 'error', onclose }) => {
    // --- CORREÇÃO: Chame o Hook ANTES de qualquer retorno condicional ---
    // O efeito agora sempre será chamado, satisfazendo as regras do React.
    useEffect(() => {
        // Apenas execute a lógica do timer se houver uma mensagem.
        if (message) {
            const timer = setTimeout(() => {
                onclose();
            }, 5000); // Fecha após 5 segundos

            // Limpa o timer se o componente for desmontado ou a mensagem mudar
            return () => clearTimeout(timer);
        }
    }, [message, onclose]);

    // Agora, podemos ter o retorno antecipado sem problemas.
    // Se não houver mensagem, o componente não renderiza nada.
    if (!message) {
        return null;
    }

    // O restante da lógica permanece o mesmo
    const alertConfig = {
        success: {
            icon: <CheckCircle size={24} color="#f0f0f0" />,
            style: styles.success,
        },
        error: {
            icon: <AlertTriangle size={24} color="#f0f0f0" />,
            style: styles.error,
        },
    };

    const config = alertConfig[type];

    return (
        <div style={styles.overlay}>
            <div style={{ ...styles.alertBox, ...config.style }}>
                <div style={styles.iconContainer}>
                    {config.icon}
                </div>
                <div style={styles.messageContainer}>
                    <p style={styles.messageText}>{message}</p>
                </div>
                <button onClick={onclose} style={styles.closeButton}>
                    <X size={20} color="#f0f0f0" />
                </button>
            </div>
        </div>
    );
};

// --- Estilos para o CustomAlert ---
const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        padding: '20px',
    },
    alertBox: {
        display: 'flex',
        alignItems: 'center',
        padding: '16px 20px',
        borderRadius: '12px',
        color: '#f0f0f0',
        minWidth: '280px',
        maxWidth: '90%',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
        border: '1px solid',
        animation: 'slideIn 0.3s ease-out forwards',
    },
    success: {
        backgroundColor: '#1a4e3a',
        borderColor: '#2a9d8f',
    },
    error: {
        backgroundColor: '#5e2a2a',
        borderColor: '#e76f51',
    },
    iconContainer: {
        marginRight: '15px',
    },
    messageContainer: {
        flex: 1,
        lineHeight: '1.4',
        textAlign: 'left',
    },
    messageText: {
        margin: 0,
        fontSize: '16px',
        fontWeight: '500',
        wordWrap: 'break-word',
    },
    closeButton: {
        background: 'transparent',
        border: 'none',
        color: '#f0f0f0',
        cursor: 'pointer',
        padding: '5px',
        marginLeft: '15px',
        alignSelf: 'flex-start',
        marginTop: '-5px',
        marginRight: '-10px',
    },
};

export default CustomAlert;